const BASE_ACTION = "LAYOUT/";
export const SET_LAYOUTS = `${BASE_ACTION}SET_LAYOUTS`;
export const SET_CURRENT_LAYOUT = `${BASE_ACTION}SET_CURRENT_LAYOUT`;
export const ADD_LAYOUT_SUCCESS = `${BASE_ACTION}ADD_LAYOUT_SUCCESS`;
export const DELETE_LAYOUT_SUCCESS = `${BASE_ACTION}DELETE_LAYOUT_SUCCESS`;
export const EDIT_LAYOUT_SUCCESS = `${BASE_ACTION}EDIT_LAYOUT_SUCCESS`;
export const RESET_LAYOUTS = `${BASE_ACTION}RESET_LAYOUTS`;
export const UPDATE_NEWLY_LAYOUT = `${BASE_ACTION}UPDATE_NEWLY_LAYOUT`;
export const SHOW_OVERLAYLAYOUT = `${BASE_ACTION}SHOW_OVERLAY_LAYOUT`;
